import { Project } from '../common/types/Projects';
import React from 'react';

export function useHasProjectChanged(project: Project): boolean {
  const ref = React.useRef<string>();

  React.useEffect(() => {
    if (!project || !project.id) {
      return;
    }

    ref.current = project.id;
  }, [project]);

  // We haven't set the project ID yet, or the project is falsy
  if (!ref.current || !project) {
    return false;
  }

  // We have set the project ID before and it has changed
  if (ref.current !== project.id) {
    return true;
  }

  return false;
}

export default useHasProjectChanged;
